angular.module('elidb').filter('refine', function() {
    return function(list,editing,model) {
    	if(!list) return null;
    	var trace = angular.trace;

		var results = [];
		if(editing) return list;
		for(var i = 0, count = list.length; i < count; i++){
			var item = list[i];
			if(model[item.id] === true) results.push(item);
		}

		return results;
    };
});